<template>


  <div class="head-wrp clear navbar" @click="showTipsList = false">
    <!-- <div v-if="isSingleAccount" class="username" @click="showLogout = !showLogout">{{currentVenue}}
      <div class="out-btn" v-if="showLogout" @click="logout">Log Out</div>
    </div> -->
    <div class="navbar__container">
      <div class="d-flex justify-content-between align-items-center w-100">
        <div>
          <div class="logo">
            <template v-if="logo">
              <img :src="logo" class="logo-img-2" alt="venue logo">
            </template>
             <span class="logo-text">PEISO</span>

            <div class="select-venue">
              <div v-if="isSingleAccount == 1" class="tit s">
                <div class="d-flex flex-column">
                  <span class="truncate truncate--2 lh-normal font-weight-bold">{{currentVenue}}</span>
                  <span v-if="instance_type == 'main' || instance_type == 'sandbox'" class="small lh-normal">{{ `(ID: ${parentId ? `${parentId}-${currentVenueId}` : currentVenueId})` }}</span>
                </div>
              </div>
              <div v-if="isSingleAccount == 0" class="tit tit-dropdown" @click="setShow()">
                <div class="d-flex flex-column">
                  <span class="truncate truncate--2 lh-normal font-weight-bold">{{currentVenue}}</span>
                  <span v-if="instance_type == 'main' || instance_type == 'sandbox'" class="small lh-normal">{{ `(ID: ${parentId ? `${parentId}-${currentVenueId}` : currentVenueId})` }}</span>
                </div>
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-down" viewBox="0 0 16 16">
                  <path fill-rule="evenodd" d="M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"/>
                </svg>
              </div>
              <div class="list" :class="{'show': showSubVenue}">
                <h1>Select Venue</h1>
                <div class="search-container">
                  <el-input v-model="searchVenue" class="peiso-input-w-prefix font-16" clearable placeholder="Search a venue">
                      <template #prefix>
                        <svg width="25" height="25" viewBox="0 0 25 25" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                          <path d="M20.7292 21.8491L13.8802 15.0002C13.3594 15.4516 12.7521 15.8031 12.0584 16.0548C11.3646 16.3066 10.6264 16.4325 9.84375 16.4325C7.96594 16.4325 6.37669 15.7814 5.07602 14.4793C3.77534 13.1772 3.125 11.6061 3.125 9.76579C3.125 7.92551 3.77604 6.35433 5.07812 5.05225C6.38021 3.75016 7.95573 3.09912 9.80469 3.09912C11.6536 3.09912 13.2248 3.75016 14.5182 5.05225C15.8116 6.35433 16.4583 7.92681 16.4583 9.76969C16.4583 10.5136 16.3368 11.2328 16.0937 11.9272C15.8507 12.6217 15.4861 13.2727 15 13.8804L21.875 20.7033L20.7292 21.8491ZM9.81771 14.87C11.2283 14.87 12.4273 14.3708 13.4147 13.3726C14.4021 12.3743 14.8958 11.172 14.8958 9.76579C14.8958 8.35954 14.4021 7.15728 13.4147 6.15902C12.4273 5.16075 11.2283 4.66162 9.81771 4.66162C8.39266 4.66162 7.18135 5.16075 6.1838 6.15902C5.18627 7.15728 4.6875 8.35954 4.6875 9.76579C4.6875 11.172 5.18627 12.3743 6.1838 13.3726C7.18135 14.3708 8.39266 14.87 9.81771 14.87Z" fill="currentColor"/>
                        </svg>
                      </template>
                  </el-input>
                </div>
                <ul v-if="!venueLoading">
                  <li class="clear" v-for="item in listOfVenues" :key="item.venueId" @click="chooseVenue(item)">
                    <div class="name">
                      <span class="font-weight-bold">{{ item.fullVenueName }} </span>
                    </div>
                    <div class="type-button" :style="{'opacity': !item.feedbackThisWeek ? '0' : '1'}"
                    :class="item.class">
                    {{(item.feedbackThisWeek === 0 || item.feedbackThisWeek > 0) ? 'Within Budget' : 'Budget Exceeded'}}
                    </div>
                    <div class="ring" v-if="item.withWarning"></div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="ml-5" viewBox="0 0 16 16">
                      <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                    </svg>
                  </li>
                </ul>
                <div class="loading-out-wrp" v-if="venueLoading"><i class="el-icon-loading" style="font-size:20px"></i></div>
                <div class="button-container">
                  <div class="to-list-btn" @click="backToVenueList">Venue summary</div>
                  <div class="out-btn" @click="logout">Log out</div>
                </div>
              </div>
            </div>
          </div>
          <div class="slt-wrp slt-wrp-mobile" v-if="$route.path.split('/')[1] =='dashboard' || $route.path.split('/')[1] =='labour'">
            <el-select style="width: 240px" v-model="time" placeholder="No Data" @change="lisKey">
              <el-option
                v-for="item in optionalList(options)"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </div>
        </div>

        <div v-if="logo">
          <img :src="logo" class="logo-img" alt="venue logo">
        </div>

        <div>
          <div  v-if="weather" class="weather-container d-flex align-items-center gap-10">
            <div class="left d-flex align-items-center">
              <img :src="weather.icon" width="60px" class="object-fit-contains" alt="">
            </div>

            <div class="right">
              <div class="temperature">
                {{ `${weather.temperature}` }}<span class="celcius">°C</span>
                <span class="d-block text-capitalize">
                  {{ weather.description }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="navbar__mobile-menu" @click="drawer = true">
        <svg v-if="!drawer" xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-list" viewBox="0 0 16 16">
          <path fill-rule="evenodd" d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5"/>
        </svg>

        <svg v-else xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
          <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
        </svg>
      </div>

    </div>

    <div class="slt-wrp slt-wrp-mobile-2" v-if="$route.path.split('/')[1] =='dashboard' || $route.path.split('/')[1] =='labour'">
      <el-select style="width: 100%" v-model="time" placeholder="No Data" @change="lisKey">
        <el-option
          v-for="item in optionalList(options)"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>







    <!--<div class="tip-wrp">Deputy – approve shifts! <i class="el-icon-message-solid"></i></div>-->
    <!--<div class="carousel" v-if="showCarousel">
      <el-carousel height="200px" direction="vertical" :autoplay="notice.length > 1 ? true : false">
        <el-carousel-item v-for="item in notice" :key="item.id">
          <h3 class="medium"><span @click="open(item.id)">{{ item.txt }}<i class="el-icon-message-solid"></i></span></h3>
        </el-carousel-item>
      </el-carousel>
    </div>-->

    <div class="carousel d-none" v-if="showCarousel">
      <h3 @click.stop="showTipsList = !showTipsList"><span>Your attention is required, tap here to learn more.</span><i class="el-icon-message-solid"></i></h3>
      <div class="list" v-if="showTipsList">
        <h3 v-for="item in notice" :key="item.id" @click.stop="open(item.id)"><span>{{ item.txt }}</span><i class="el-icon-message-solid"></i></h3>
      </div>
    </div>

    <transition name="fade">
      <div class="pop-wrp" v-if="shownamelist" style="display:flex;flex-direction:row;align-items:center;justify-content:center">
        <div class="name-wrap">
          <div class="close" @click="hidenamelist"><i class="el-icon-close"></i></div>
          <h1>Found {{namelist.length}} employees of uncertain type!</h1>
          <h2>Please add his employment contract in the deputy, or add employee<br />
information in the employee list of peiso .</h2>
          <ul v-if="namelist.length > 0">
            <li @click="showaskoperate(item.txt, item.id)" v-for="item in namelist" :key="item.id">{{item.txt}}<div class="add">To Add <i class="el-icon-arrow-right"></i></div></li>
          </ul>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="pop-wrp" v-if="showask" style="display:flex;flex-direction:row;align-items:center;justify-content:center">
        <div class="ask-wrap">
          <div class="close" @click="hideask"><i class="el-icon-close"></i></div>
          <h1>Do you need to add <span>{{curname}}</span> to the roster?</h1>
          <div class="btns clear-float">
            <button @click="hideask">Ignore</button>
            <button @click="jump">Go Add</button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="pop-wrp" v-if="shownamelist2" style="display:flex;flex-direction:row;align-items:center;justify-content:center">
        <div class="name-wrap">
          <div class="close" @click="hidenamelist2"><i class="el-icon-close"></i></div>
          <h1>Found that {{namelist2.length}} employees are not on the roster!</h1>
          <h2>Please confirm the reason for not being on the roster.</h2>
          <ul v-if="namelist2.length > 0">
            <li style="padding-right:140px" @click="showaskoperate2(item.txt, item.id)" v-for="item in namelist2" :key="item.id">{{item.txt}}<div class="add">To Confirm <i class="el-icon-arrow-right"></i></div></li>
          </ul>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div class="pop-wrp" v-if="showask2" style="display:flex;flex-direction:row;align-items:center;justify-content:center">
        <div class="ask-wrap" style="width:740px" v-if="step === 1">
          <div class="close" @click="hideask2"><i class="el-icon-close"></i></div>
          <h1>Have <span>{{curname2}}</span> left the business?</h1>
          <div class="btns clear-float">
            <button @click="next1">No</button>
            <button @click="next2">Yes</button>
          </div>
        </div>
        <div class="ask-wrap" style="width:740px" v-if="step === 2">
          <div class="close" @click="hideask2"><i class="el-icon-close"></i></div>
          <h1>Have <span>{{curname2}}</span> on leave?</h1>
          <div class="btns clear-float">
            <button @click="next3">No</button>
            <button @click="next4">Yes</button>
          </div>
        </div>
        <div class="ask-wrap" style="width:740px;padding-bottom:65px" v-if="step === 3">
          <div class="close" @click="hideask2"><i class="el-icon-close"></i></div>
          <h1>Please roster "<span>{{curname2}}</span>" on！</h1>
          <button class="confirm" @click="confirmhideask2">Confirm</button>
        </div>
        <div class="ask-wrap" style="width:740px" v-if="step === 5">
          <div class="close" @click="hideask2"><i class="el-icon-close"></i></div>
          <h1>How much leave time Aaron Miles are taking?</h1>
          <div class="inputItem">
            <input type="text" maxlength="3" v-model="leavetime" @input="leavetime = leavetime.replace(/[^\d]/g,'')" />
            <i>Day</i>
          </div>
          <div class="btns clear-float">
            <button @click="hideask2">Cancel</button>
            <button @click="next5">Confirm</button>
          </div>
        </div>
        <div class="ask-wrap" style="width:740px;padding-bottom:65px" v-if="step === 4">
          <div class="close" @click="hideask2"><i class="el-icon-close"></i></div>
          <h1>How many accrued leave does he have left?</h1>
          <div class="inputItem">
            <input type="text" maxlength="3" v-model="accrued" @input="accrued = accrued.replace(/[^\d]/g,'')" />
            <i>Day</i>
          </div>
          <div class="btns clear-float">
            <button @click="hideask2">Cancel</button>
            <button @click="next6">Confirm</button>
          </div>
        </div>
        <div class="ask-wrap" style="width:740px" v-if="step === 6">
          <div class="close" @click="hideask2"><i class="el-icon-close"></i></div>
          <h1>He has been set as inactive in the roster!</h1>
          <button class="confirm" @click="hideask2">Confirm</button>
        </div>
      </div>
    </transition>
    <!-- <button @click="test">test click</button> -->

    <el-dialog
      title=""
      :visible.sync="showlst"
      :modal-append-to-body="false"
      :show-close="false"
      class="delEmployDio pad-rgt-0 customize-dialog"
      :close-on-click-modal="false"
      width="1300px"
      center
    >
      <TreeTable title="" :currentWeek="thisweek"
      :weekStart="weekStart"
      :hasLabour="hasLabour"
      subtitle="Please enter actual revenue & expenses of last week to make forecast for next week."
      :minititle="lastWeek"
      text="Please enter the actual sales, we will subtract the commission to calculate the net revenue."
      @cancel="showlst = false"
      :list="tableData" :loading="loading2"
      @confirm="confirmUpdate" :requesting="tableConfirming" />
    </el-dialog>


    <!--如果发现实际收入连续两周没有输入，那么用户登录Peiso后将立即弹出导入CSV弹出窗口，提醒用户导入之前19周的收入-->
    <div class="pop-wrp" v-if="longWeek">
      <div class="second-step">
        <h1>You have not used Peiso for a long time, please let us know about your recent.</h1>
        <h2>Please download the most recent 19 weeks ({{pastWeek}}) of<br />income history from your Point of Sale and upload the .csv file here.</h2>
        <div class="upload-con" v-if="!longWeekuploaded">
          <i class="icon" v-if="!longWeekuploading"></i>
          <h3 v-if="!longWeekuploading">Drag the file here, or <span>Click to upload</span><br />Only Excel files can be uploaded</h3>
          <div class="demo">
          <el-upload
            v-if="!longWeekuploading"
            class="upload-demo"
            drag
            action=""
            multiple
            :http-request="longWeekexcelUpload"
            :show-file-list="false">
          </el-upload>
          </div>
          <i class="el-icon-loading" v-if="longWeekuploading"></i>
        </div>
        <div class="upload-con" v-if="longWeekuploaded">
          <div class="file">
            <div class="in"></div>
            <div class="text">
              <div class="tit" style="color:#fff">{{longWeekname}}</div>
              <div class="size" style="color:#fff">{{longWeeksize}}k</div>
            </div>
          </div>
          <div class="close" @click="longWeekremove"></div>
        </div>
        <div class="btns clear">
          <button class="dark" @click="longWeekcancel">Cancel</button>
          <button class="light" :disabled="longWeekdisable" :class="{'usable': !longWeekdisable}" @click="longWeekcontinue">Confirm</button>
        </div>
      </div>
    </div>

    <transition name="fade" v-if="longWeekshowconfirm">
      <div class="pop-wrp">
        <div class="pop-confirm">
          <h1 style="padding-top: 50px;margin-bottom: 65px;text-align:center">Data already exists on part of the date. Do you want to overwrite it?</h1>
          <div class="triple">
            <button @click="longWeekcloseconfirm('cancel')">Cancel</button>
            <button @click="longWeekcloseconfirm('over')">Overwrite Data</button>
            <button @click="longWeekcloseconfirm('keep')">Keep Original Data</button>
          </div>
        </div>
      </div>
    </transition>


    <el-drawer
      class="mobile-sidebar"
      title="Peiso"
      :visible.sync="drawer"
      :direction="'ltr'"
      :with-header="false">

      <nav-con />

    </el-drawer>

  </div>
</template>

<script>
import api from '../../api/dashboard'
import Api from '../../api/api'
import apiLogin from '../../api/login'
import {mapMutations} from 'vuex'
import treeTable from "../dashboard/component/treeTable.vue";
import navCon from '@/components/nav/navcon'
import _ from 'lodash';

export default {
  name: 'headcon',
  inject:['reload', 'hidden', 'show2'],
  data () {
    return {
      hasLabour: true,

      tableConfirming: false,
      venueType: sessionStorage.getItem('venueType'),
      currentVenue: sessionStorage.getItem('subVenueName'),
      currentVenueId: sessionStorage.getItem('subVenueId'),
      parentId: sessionStorage.getItem('parentId'),
      isSingleAccount: parseInt(sessionStorage.getItem('isSingleAccount')),
      showSubVenue: false,
      venueList: [],
      venueLoading: false,

      venueName: sessionStorage.getItem('venueName'),
      showLogout: false,
      showCarousel: false,
      showTipsList: false,
      time: 'THIS WEEK',

      drawer: false,
      /*options: [{
        value: 1,
        label: 'THIS WEEK'
      },{
        value: 2,
        label: 'LAST WEEK'
      },{
        value: 3,
        label: 'NEXT WEEK'
      }],*/
      options: [],
      notice: [],
      shownamelist: false, // 是否展示名字列表
      namelist: [],
      showask: false,
      curname: null,
      curid: null,

      shownamelist2: false, // 是否展示名字列表
      namelist2: [],
      showask2: false,
      curname2: null,
      curid2: null,
      step: 1,
      leavetime: '',
      accrued: '',

      showlst: false,
      dataHght: '',
      lastWeek: '',
      lastWeekTimestamp: [],
      loading2:false,

      longWeek: false,
      longWeekuploading: false,
      longWeekuploaded: false,
      longWeekname: null, // 文件名
      longWeeksize: null, // 文件大小
      longWeekdisable: true, // 默认是true
      longWeekshowconfirm: false,
      longWeektempFormdata: null,
      longWeektemp: null,
      pastWeek: '',

      thisweek: [],
      currentValue: null,

      tableData: [],

      syncWeekStartWithDeputy: false,
      weekStart: 0,
      searchVenue: '',
      isPro: false,
      weather: null,
      logo: process.env.LOGO,
      instance_type: process.env.INSTANCE_TYPE,
    }
  },
  props: {
    fourWeeksAvg: null,
    status: {
      type: Number,
      default: 888
    }
  },
  mounted () {
    if (!window.sessionStorage.getItem("token")) {
      this.$router.replace('/login')
      return
    }
    
    this.getLatestWeatherUpdate()
    this.getTime()
    
    if (this.venueType === '1') {
      this.getSubVenue()
    }

    // 获取提示语
    //  api.tip({callback: this.tipCallback})
    this.getPastWeek()

    this.$root.$on('logout-venue', () => {
      this.logout()
    })

  },
  methods: {
    optionalList (options) {
      const optionList = options.map((item) => {
        switch (item.label) {
          case 'THIS WEEK':
            return {...item, order: 0}
          case 'LAST WEEK':
            return {...item, order: -1}
          case 'NEXT WEEK':
            return {...item, order: 1}
          default:
            return {...item, order: item.value}
        }
      });

      return _.orderBy(optionList, ['order'], 'asc');
    },
    getPastWeek() {
      var startTimestamp2
      var endTimestamp2
      let week = new Date().getDay() === 0 ? 7 : new Date().getDay()
      let millisecond = 86400000
      let current = new Date().getTime()

      if (week === 1) {
        startTimestamp2 = current - ((7 + 18 * 7) * millisecond)
        endTimestamp2 = current - millisecond
      } else if (week === 2) {
        startTimestamp2 = current - ((8 + 18 * 7) * millisecond)
        endTimestamp2 = current - (2 * millisecond)
      } else if (week === 3) {
        startTimestamp2 = current - ((9 + 18 * 7) * millisecond)
        endTimestamp2 = current - (3 * millisecond)
      } else if (week === 4) {
        startTimestamp2 = current - ((10 + 18 * 7) * millisecond)
        endTimestamp2 = current - (4 * millisecond)
      } else if (week === 5) {
        startTimestamp2 = current - ((11 + 18 * 7) * millisecond)
        endTimestamp2 = current - (5 * millisecond)
      } else if (week === 6) {
        startTimestamp2 = current - ((12 + 18 * 7) * millisecond)
        endTimestamp2 = current - (6 * millisecond)
      } else if (week === 7) {
        startTimestamp2 = current - ((13 + 18 * 7) * millisecond)
        endTimestamp2 = current - (7 * millisecond)
      }
      var start2 = Utils.timeFotmatYMD(startTimestamp2)
      var end2 = Utils.timeFotmatYMD(endTimestamp2)
      this.pastWeek = `${start2} - ${end2}`

    },
    confirmUpdate(params){
      if (this.tableConfirming)
        return
      this.tableConfirming = true
      api.updateActualIncome({
        params: params,
        callback: this.updateCallback,
      });
    },
    setShow () {
      this.showSubVenue = !this.showSubVenue
      if (this.showSubVenue)
        this.getSubVenue()
    },
    chooseVenue (item) {
      sessionStorage.setItem('subVenueName', item.venueName)
      sessionStorage.setItem('subVenueId', item.venueId)
      
      if (item.parentId) {
          sessionStorage.setItem('parentId', item.parentId);
      } else {
        sessionStorage.removeItem('parentId');
      }
      sessionStorage.removeItem('isContUsingTrial')
      // Utils.loadings();
      this.loadDatum();
    },
    async loadDatum() {
        await Api.checkDashboardV2()
        await Api.checkEosEnable()
        window.location.reload()
    },
    getSubVenue () {
      var that = this
      apiLogin.getSubVenueList({
          callback: (res) => {
              that.venueLoading = false
              let {code,data,message}=res.data
              if (code === 0) {
                  data.forEach(item => {
                      if (item.feedbackThisWeek === 0 && !item.withWarning) {
                          item.class = 'green'
                      } else if (item.feedbackThisWeek === 0 && item.withWarning) {
                          item.class = 'white'
                      } else if (item.feedbackThisWeek > 0 && !item.withWarning) {
                          item.class = 'green'
                      } else if (item.feedbackThisWeek > 0 && item.withWarning) {
                          item.class = 'white'
                      } else if (item.feedbackThisWeek < 0) {
                          item.class = 'red'
                      }
                  })

                  that.venueList = data
              } else {
                  Utils.alert('', `error on getSubVenueList: ${message}`, 'error')
              }
          }
      })

    },
    logout () {
      this.showLogout = false
      apiLogin.logout({
        callback: (res) => {
          const venues = localStorage.getItem('venues');
          const venueId = localStorage.getItem('venueId');

          sessionStorage.clear()
          localStorage.clear()


          if (venues) {
              localStorage.setItem('venues', venues);
              localStorage.setItem('venueId', venueId);
          }

          this.$router.replace('/login')
          if(res.data.code == 0){
            //
          } else if (res.data.code == 8902) {
            //
          } else{
            Utils.alert('', res.data.message, 'error')
          }
        }
      })
    },

    backToVenueList() {
      sessionStorage.removeItem('subVenueId')
      sessionStorage.removeItem('subVenueName')
      localStorage.removeItem('blId')
      localStorage.removeItem('kseriesState')
      localStorage.removeItem('apiType')
      localStorage.removeItem('kseriesCode')

      this.$router.push({name: "venueselect"});
    },
    getTime(){
      this.$emit('weekEvt', null)
      Api.getTimeList(res=>{
        if (!res || !res.data) {
          return
        }
        this.$root.$emit('optional-list', res)
        this.syncWeekStartWithDeputy = res.data.data.syncWeekStartWithDeputy
        this.weekStart = res.data.data.syncWeekStartWithDeputy ? res.data.data.weekStart : 1
        this.options = []
        if(res.data.code == 0){
          res.data.data.list.forEach((item => {
            if (item.dashBoardId === null)
              item.dashBoardId = item.value
          }))

          // 记录有无this week
          let this_week = 0
          // 记录有无last week
          let last_week = 0
          // 记录有无next week
          let next_week = 0
            res.data.data.list.forEach((i, n) => {
              this.options.push({
                value: i.dashBoardId === null || i.dashBoardId == 0 ? i.value : i.dashBoardId,
                label: i.value
              })
              if (i.value === 'THIS WEEK') {
                if (this.currentValue === null){
                  this.$emit('weekEvt', i.dashBoardId ? i.dashBoardId : i.value)
                  this.currentValue = i.dashBoardId ? i.dashBoardId : i.value
                } else {
                  this.$emit('weekEvt', this.currentValue)
                }
                if (res.data.data.list[n + 1] && res.data.data.list[n + 1].value !== 'NEXT WEEK') {
                  this.options.push({
                    value: -3,
                    label: 'NEXT WEEK'
                  })
                  next_week = 1
                }
              } else if (i.value === this.currentValue) {
                this.$emit('weekEvt', i.dashBoardId ? i.dashBoardId : i.value)
              }
              if (i.value === 'LAST WEEK' && i.dashBoardId !== -2) {
                this.lastWeekTimestamp = []
                this.lastWeekTimestamp.push(i.monDateTime)
                this.lastWeekTimestamp.push(i.sunDateTime)
                // 获取提示语
                // api.tip({callback: this.tipCallback})
              }
              if (i.value === 'THIS WEEK') {
                this_week = 1
              }
              if (i.value === 'LAST WEEK') {
                last_week = 1
              }
              if (i.value === 'NEXT WEEK') {
                next_week = 1
              }
            })
          if (this_week === 0) {
            this.options.unshift({
              value: -1,
              label: "THIS WEEK"
            })
            if (this.currentValue === null) {
              this.$emit('weekEvt', -1)
              this.currentValue = "THIS WEEK"
            } else {
              this.$emit('weekEvt', this.currentValue)
            }
            if (next_week === 0) {
              this.options.push({
                value: -3,
                label: 'NEXT WEEK'
              })
              next_week = 1
            }

          }
          if (last_week === 0) {
            this.options.unshift({
              value: -2,
              label: 'LAST WEEK'
            })
          }
          if (next_week === 0) {
            this.options.push({
              value: -3,
              label: 'NEXT WEEK'
            })
          }

          api.progress({
            callback: (res) => {
              sessionStorage.setItem('deputyFlag', res.data.data.deputyFlag)
              sessionStorage.setItem('tandaFlag', res.data.data.tandaFlag)
              var result = res.data.data
              // peiso lite
              this.isPro = result.isPro ? true : false

              if (!this.isPro && sessionStorage.getItem('isPinNeeded') == '1') {
                sessionStorage.setItem('isPinNeeded', 0)
              }

              var isSingleAccount = parseInt(sessionStorage.getItem('isSingleAccount'))
              var others = {
                isBudgetingActivated: result.isBudgetingActivated,
                isRevenueTargetForecastActivated: result.isRevenueTargetForecastActivated,
                isAccountingPlatformActivated: result.isAccountingPlatformActivated,
                isSingleAccount: isSingleAccount,
                tandaFlag: result.tandaFlag,
              }

              if (result.venueDiscountDetailsPojo && result.venueDiscountDetailsPojo.type == 'trial') {
                const isContUsingTrial = sessionStorage.getItem('isContUsingTrial')
                if (!isContUsingTrial) {
                  sessionStorage.setItem('isContUsingTrial', '0')
                }
                others.venueDiscountDetailsPojo = result.venueDiscountDetailsPojo
              } else {
                others.venueDiscountDetailsPojo = null
              }

              this.$root.$emit('isPro', this.isPro, others)

              if (sessionStorage.getItem('deputyFlag') == 'true') {
                api.tip({callback: this.tipCallback})
              }

            }
          })

        } else if (res.data.code == 8902) {
          sessionStorage.clear()
          this.$router.push('/login')
        } else{
          Utils.alert('', res.data.message, 'error')
        }
      })
    },
    // 上传文件
    longWeekexcelUpload (e) {
      var that = this
      const name = e.file.name.split('.')
      const type = name[name.length - 1]
      if (type !== 'csv') {
        Utils.alert('', 'Please upload the.cvs file', 'error')
        return
      }
      // 在这里调接口
      var formData = new FormData()
      formData.append("file", e.file)
      that.longWeekname = e.file.name
      that.longWeeksize = (e.file.size / 1024).toFixed(1)
      that.longWeektempFormdata = formData
      that.longWeekuploaded = true
      that.longWeekdisable = false
    },
    longWeekcontinue() {
      var that = this
      that.longWeekuploading = true
      that.longWeekuploaded = false
      api.upload({
        params: that.longWeektempFormdata,
        type: 2,
        callback: that.longWeekuploadCallback
      })
    },
    longWeekuploadCallback (res) {
      var that = this
      that.longWeekuploading = false
      that.longWeekuploaded = true
      if(res.data.code == 0){
        // 数据正常
        that.queryTemporary(1)

      } else if (res.data.code === 10002) {
        // 有重复数据，展开二次确认弹框
        that.longWeekshowconfirm = true
        that.longWeektemp = res.data.data
      } else if (res.data.code == 8902) {
        sessionStorage.clear()
        this.$router.push('/login')
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    longWeekcancel() {
      var that = this
      if (that.longWeekuploading) {
        return
      }
      that.longWeek = false
      that.longWeekuploaded = false
      that.longWeekname = null
      that.longWeeksize = null
      that.longWeekdisable = true
      that.longWeektempFormdata = null
      that.longWeektemp = null
    },
    longWeekcloseconfirm (type) {
      if (type === 'cancel') {
        this.longWeek = false
        this.longWeekshowconfirm = false
      } else if (type === 'over') {
        Utils.loadings()
        api.over({
          params: {
            map: this.longWeektemp,
            overwriteFlag: true,
            uploadType: 2
          },
          callback: this.longWeekcloseCallback
        })
      } else if (type === 'keep') {
        Utils.loadings()
        api.over({
          params: {
            map: this.longWeektemp,
            overwriteFlag: false,
            uploadType: 2
          },
          callback: this.longWeekcloseCallback
        })
      }
    },
    longWeekcloseCallback (res) {
      var that = this
      Utils.loadings(2)
      that.longWeek = false
      that.longWeekuploaded = false
      that.longWeekname = null
      that.longWeeksize = null
      that.longWeekdisable = true
      that.longWeekshowconfirm = false
      that.longWeektempFormdata = null
      that.longWeektemp = null
      if(res.data.code == 0){
        that.reload()
      } else if (res.data.code == 8902) {
        sessionStorage.clear()
        this.$router.push('/login')
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    longWeekremove () {
      this.longWeekuploaded = false
      this.longWeekname = null
      this.longWeeksize = null
      this.longWeekdisable = true
    },
    tipCallback (res) {
      var that = this
      if(res.data.code == 0){
        if (res.data.data.approveShifts === true ||
        res.data.data.noContractSet ||
        res.data.data.noIncomeCount > 0 ||
        Object.keys(res.data.data.notRoster).length > 0 ||
        res.data.data.profitLossEdit === true ||
        res.data.data.unsubscribedPlatform.length > 0 ||
        sessionStorage.getItem('doshiiLinked') === '1') {
        //res.data.data.noSatAndSunIncomeCount) {
          this.showCarousel = true
        } else {
          this.showCarousel = false
        }
        this.notice = []

        if (sessionStorage.getItem('doshiiLinked') === '1') {
          this.notice.push({
            txt: `Your Doshii account has been successfully linked.`,
            id: 11
          })
        }


        this.namelist = []
        this.namelist2 = []
        if (res.data.data.approveShifts === true) {
          this.notice.push({
            txt: `${res.data.data.rosterType === 'deputy' ? 'Deputy' : (res.data.data.rosterType === 'tanda' ? 'Tanda' : '')} - approve shifts!`,
            id: 1
          })
        }
        if (res.data.data.noContractSet && res.data.data.noContractSet.length > 0) {
          this.notice.push({
            txt: `Deputy - found ${res.data.data.noContractSet.length} employees of uncertain type!`,
            id: 2
          })

          res.data.data.noContractSet.forEach(name => {
            this.namelist.push({
              txt: name,
              id: name
            })
          })
        }
        // 如果是1你就点击提示语去调用查询上周实际收入
        if (res.data.data.noIncomeCount === 1) {
          this.notice.push({
            txt: "Peiso-You haven't entered your actual income for the last week!",
            id: 4
          })
          /*if (window.sessionStorage.getItem('noIncome1') && window.sessionStorage.getItem('noIncome1') === '1') {
            window.sessionStorage.removeItem('noIncome1')
            this.showIncome()
            // this.openDashboard()
          }*/
        }

        if (res.data.data.noIncomeCount > 1) {
          this.notice.push({
            txt: "Peiso-You haven't entered your actual income for the last week!",
            id: 33
          })
        }

        /*if (res.data.data.noSatAndSunIncomeCount) {
          this.notice.push({
            txt: "Please enter last weeks revenue",
            id: 66
          })
        }*/


        /* if (res.data.data.notOnCost === true) {
          this.notice.push({
            txt: "Please add super oncost into deputy.",
            id: 88
          })
        } */

        // Peiso需要提前获得下周Deputy的Roster，如果没有得到Roster，则会发出警报，警告会提醒哪个区间的Roster没有获取到
        if (Object.keys(res.data.data.notRoster).length > 0) {
          let _arr = []
          for(let key in res.data.data.notRoster){
            _arr.push({
              month: key,
              value: res.data.data.notRoster[key]
            })
            this.notice.push({
              txt: `Did not get the nearest roster (${key} ${res.data.data.notRoster[key]})`,
              id: key
            })
          }
        }
        /*if (res.data.data.holidayTips.length > 0) {
          for(let key in res.data.data.holidayTips){
            this.notice.push({
              txt: `Peiso - ${res.data.data.holidayTips[key].remark} holiday is ${res.data.data.holidayTips[key].hasBegun === true ? 'has begun' : 'comming soon'}! (${res.data.data.holidayTips[key].tips})`,
              id: key.remark
            })
          }
        }*/
        if (res.data.data.profitLossEdit === true) {
          this.notice.push({
            txt: `Admin has enabled manual set Profit & Loss.`,
            id: 9
          })
        }
        // 2021/12/30
        if (res.data.data.unsubscribedPlatform.length > 0) {
          res.data.data.unsubscribedPlatform.forEach(name => {
            this.notice.push({
              txt: `${name} has been disconnected, please reconnect.`,
              id: name
            })
          })
        }
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    lisKey (e) {
      this.options.forEach((i) => {

        if (i.value === e) {
          this.currentValue = i.value
          this.$emit('weekEvt', e)
        }
      })
    },
    hidenamelist () {
      this.shownamelist = false
    },
    hideask () {
      Utils.loadings()
      api.neglect2({
        params: {
          displayName: this.curid
        },
        callback: this.hideaskCallback
      })
    },
    hideaskCallback (res) {
      Utils.loadings(2)
      this.showask = false
      this.shownamelist = false
      if (res.data.code === 0) {
        // 获取提示语
        api.tip({callback: this.tipCallback})
      } else {
        Utils.alert('', res.data.message, 'error')
      }
    },
    hideaskCallback2 (res) {
      Utils.loadings(2)
      this.showask2 = false
      this.step = 1
      this.shownamelist2 = false
      if (res.data.code === 0) {
        // 获取提示语
        api.tip({callback: this.tipCallback})
        this.setEmployeeFresh({data: true})
      } else {
        Utils.alert('', res.data.message, 'error')
      }
    },
    showaskoperate (name, id) {
      this.curname = null
      this.curid = null
      this.curname = name
      this.curid = id
      this.showask = true
    },
    test () {
      // 去到指定路由
      window.sessionStorage.setItem('otherFrom',false)
      this.$router.push({name:'employee',params: {name:'45.54544545'}})
      window.sessionStorage.setItem('framdashborad',true)
      this.showask = false
      this.shownamelist = false
      this.shownamelist2 = false
      this.setOtherFrom({data: '455454.5877878'})
    },
    jump () {
      // 去到指定路由
      window.sessionStorage.setItem('otherFrom',false)
      this.$router.push({name:'employee',params: {name:this.curid}})
      window.sessionStorage.setItem('framdashborad',true)
      this.showask = false
      this.shownamelist = false
      this.shownamelist2 = false
      this.setOtherFrom({boo: false, name: this.curid})
    },
    ...mapMutations([
      'setOtherFrom', 'setFresh', 'setEmployeeFresh', 'openDashboard', 'closeDashboard'
    ]),
    showIncome () {
      if (!this.lastWeekTimestamp[1] || this.weekStart === 0)
        return
      this.showlst = true
      this.tableData = []
      this.loading2 = true
      let _params = {
        incomeType: 0
      }
      _params.monDateTime = this.lastWeekTimestamp[0]
      _params.sunDateTime = this.lastWeekTimestamp[1]

      var start = Utils.timeFotmatYMD(_params.monDateTime * 1000)
      var end = Utils.timeFotmatYMD(_params.sunDateTime * 1000)
      this.lastWeek = `${start} - ${end}`
      this.thisweek = this.$box.loadWeekDatum(_params.monDateTime)

      api.getActualIncome({
        params: _params,
        callback: this.incomeCallback
      })
      //this.hidden()
    },
    incomeCallback (res) {
      var that = this
      that.loading2 = false
      that.hasLabour = false
      if(res.data.code == 0){
        let data = res.data.data
        // 11.15
        let tableDatum  = [
          {
            left: 'Total',
            mon: data.total.mon,
            tues: data.total.tue,
            wed: data.total.wed,
            thu: data.total.thu,
            fri: data.total.fri,
            sat: data.total.sat,
            sun: data.total.sun,
            shrink: false,
            color: 'green',
            son: []
          }
        ]
        if (data.list && data.list[0]) {
          data.list.forEach((item) => {
              let temp = []
              if (item.actualIncomeList && item.actualIncomeList[0]) {
                item.actualIncomeList.forEach(i => {
                  temp.push({
                    left: i.incomeName,
                    mon: i.mon,
                    tues: i.tue,
                    wed: i.wed,
                    thu: i.thu,
                    fri: i.fri,
                    sat: i.sat,
                    sun: i.sun,

                    editmon: false,
                    edittues: false,
                    editwed: false,
                    editthu: false,
                    editfri: false,
                    editsat: false,
                    editsun: false,

                    withDollar: item.expensesType !== 3 ? true : false,
                    color: item.expensesType !== 3 ? 'green' : (i.revenueType === 3 ? 'pink' : ''),

                    monDateTime: i.monDateTime,
                    sunDateTime: i.sunDateTime,
                    revenueType: i.revenueType,
                    incomeType: i.incomeType,
                    id: i.id,
                    incomeId: i.incomeId,

                    expensesType: item.expensesType,
                    incomeCommission: i.incomeCommission,
                    ofDoshii: i.revenueFrom === 0 ? false : true
                  })
                })
              }
              if (item.expensesType === 4) {
                that.hasLabour = true
                tableDatum[0].son.push({
                  left: 'Labour',
                  mon: temp[0].mon,
                  tues: temp[0].tues,
                  wed: temp[0].wed,
                  thu: temp[0].thu,
                  fri: temp[0].fri,
                  sat: temp[0].sat,
                  sun: temp[0].sun,
                  shrink: false,
                  color: 'white',
                  son: [],
                  hideArrow: true,

                  monDateTime: temp[0].monDateTime,
                  sunDateTime: temp[0].sunDateTime,
                  revenueType: temp[0].revenueType,
                  incomeType: temp[0].incomeType,
                  id: temp[0].id,
                  incomeId: temp[0].incomeId,

                  expensesType: item.expensesType,
                  incomeCommission: temp[0].incomeCommission,
                  editmon: false,
                  edittues: false,
                  editwed: false,
                  editthu: false,
                  editfri: false,
                  editsat: false,
                  editsun: false,
                  ofDoshii: temp[0].ofDoshii
                })
              } else
              tableDatum[0].son.push({
                left: item.expensesType === 1 ? 'Revenue' : (item.expensesType === 2 ? 'Delivery' : (item.expensesType === 3 ? 'Expenses' : '')),
                mon: item.total.mon,
                tues: item.total.tue,
                wed: item.total.wed,
                thu: item.total.thu,
                fri: item.total.fri,
                sat: item.total.sat,
                sun: item.total.sun,
                shrink: false,
                color: item.expensesType !== 3 ? 'green' : 'pink',
                son: temp,
                expensesType: item.expensesType,
              })
          })
          that.tableData = tableDatum
        }
      } else if (res.data.code == 8902) {
        sessionStorage.clear()
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    queryTemporary (type) {
      Utils.loadings()
      this.querying = true
      api.queryTemporary({callback: this.queryCallback, type: type})
    },
    queryCallback (res, type) {
      var that = this
      Utils.loadings(2)
      that.querying = false
      if (res.data.code === 0) {
        if (type === 1) {
          that.reload()
        } else if (type === 2) {
          this.showlst = false
          this.show2()
          this.closeDashboard()
          this.openDashboard()
          this.reload()
        }
      } else if (res.data.code == 8902) {
        sessionStorage.clear()
        this.$router.push('/login')
      } else {
        Utils.alert('', res.data.message, 'error')
      }
    },
    updateCallback (res) {
      var that = this
      that.tableConfirming = false
      if(res.data.code == 0){
        this.queryTemporary(2)

      } else if (res.data.code == 8902) {
        sessionStorage.clear()
        this.$router.push('/login')
      } else{
        Utils.alert('', res.data.message, 'error')
      }
    },
    open (id) {
      this.showTipsList = false
      if (id === 2) {
        this.shownamelist = true
      } else if (id === 4) {
        // 通过vuex让dashboard打开
        // this.openDashboard()
        this.showIncome()
      } else if (id === 9) {
        // 跳转到设置
        api.clear({
          callback: (res) => {
            if (res.data.code === 0) {
              this.setFresh({data: true})
            } else {
              Utils.alert('', res.data.message, 'error')
            }
          }
        })
        this.$router.push('/setting')
      } else if (id === 33) {
        this.longWeek = true
      }

      /* else if (id === 3) {
        this.shownamelist2 = true
      } */
    },
    hidenamelist2 () {
      this.shownamelist2 = false
    },
    hideask2 () {
      this.showask2 = false
      this.step = 1
      this.leavetime = ''
      this.accrued = ''
      this.shownamelist2 = false
    },
    confirmhideask2 () {
      Utils.loadings()
      api.neglectstaff({
        params: {
          displayName: this.curid2
        },
        callback: this.hideaskCallback2
      })
    },
    next1 () {
      // 在第一个弹窗选了no
      this.step = 2
    },
    next3 () {
      this.step = 3
    },
    next4 () {
      this.step = 5
    },
    next5 () {
      if (this.leavetime === '')
        return
      Utils.loadings()
      api.beOnLeave({
        params: {
          displayName: this.curid2,
          holiday: parseInt(this.leavetime)
        },
        callback: this.nextCallback
      })
    },
    nextCallback (res) {
      Utils.loadings(2)
      this.showask2 = false
      this.step = 1
      this.leavetime = ''
      this.accrued = ''
      this.shownamelist2 = false
      if (res.data.code === 0) {
        // 获取提示语
        api.tip({callback: this.tipCallback})
        this.setEmployeeFresh({data: true})
      } else {
        Utils.alert('', res.data.message, 'error')
      }
    },
    showaskoperate2 (name, id) {
      this.curname2 = null
      this.curid2 = null
      this.curname2 = name
      this.curid2 = id
      this.showask2 = true
    },
    next2 () {
      // 在第一个弹窗选了yes
      this.step = 4
    },
    next6 () {
      if (this.accrued === '')
        return
      Utils.loadings()
      api.toInactive({
        params: {
          displayName: this.curid2,
          holiday: parseInt(this.accrued)
        },
        callback: this.toInactiveCallback
      })
    },
    toInactiveCallback (res) {
      Utils.loadings(2)
      if (res.data.code === 0) {
        this.accrued = ''
        this.step = 6
        // 获取提示语
        api.tip({callback: this.tipCallback})
        this.setEmployeeFresh({data: true})
      } else {
        Utils.alert('', res.data.message, 'error')
      }
    },
    getPath(){
      // 获取提示语
      // if (sessionStorage.getItem('deputyFlag') == 'true') {
      //   api.tip({callback: this.tipCallback})
      // }
      this.setFresh({data: false})
      this.getTime()
    },

    async getLatestWeatherUpdate() {
      return
      var venueId = sessionStorage.getItem('subVenueId')
      const res = await Api.latestWeatherUpdate({id: venueId})
      if (res.data.code != 0) {
        sessionStorage.setItem('weather-status', null)
      } else {

        var weather = res.data.data
        if (weather) {
          sessionStorage.setItem('weather-status', JSON.stringify(weather))
          this.weather = JSON.parse(sessionStorage.getItem('weather-status'))
        }

      }

    }
  },
  watch: {
    'status': {
        deep: true,
        handler: function (val) {
          // 获取提示语
          api.tip({callback: this.tipCallback})
          this.setFresh({data: false})
        }
    },
    fourWeeksAvg(n,o){
      // console.log('this.fourWeeksAvg = val')
    },
    isFresh(n,o){
        if(n === true){
            api.tip({callback: this.tipCallback})
            this.setFresh({data: false})
        }
    },
    '$route':'getPath'
  },
  computed: {
    isFresh(){
      return this.$store.state.headfresh
    },
    listOfVenues() {
      var venue = []
      var venueName = sessionStorage.getItem('subVenueName')
      this.venueList = this.venueList.filter((n) => n.venueName != venueName)
      
      this.venueList.map((n) => {
          n.fullVenueName = n.parentId ? `${n.venueName} (${n.parentId} - ${n.venueId})` : `${n.venueName} (${n.venueId})`
          n.forSearch = n.parentId ? `${n.venueName} ${n.parentId} - ${n.venueId}` : `${n.venueName} ${n.venueId}`
          return n
      })
      if (this.venueList.length) {
        venue = this.venueList.filter((res) => {
          return res.forSearch.toLowerCase().includes(this.searchVenue.toLowerCase())
        })
      }

      return venue
    },
  },
  components: { TreeTable: treeTable, navCon },
}
</script>

<style lang="scss" scoped>
@import 'static/scss/colors';
@import 'static/scss/fonts/fonts';
@import 'static/scss/scrollbar';

.head-wrp{
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  background: var(--background-color);
  height: 182px;
  z-index: 101;
  box-sizing: border-box;
  padding-left: 30px;
  padding-right: 60px;
  /*min-width: 1100px; */
  .ml-5 {
    margin-left: 20px;
  }
  .tit-dropdown {
    display: flex;
    align-items: center;
    gap: 20px;
  }

  .logo-img {
    height: 80px;
    position: relative;
    top: 20px;
    left: -100px;
  }

  .logo-img-2 {
    height: 50px;
    position: relative;
    display: none;
    top: -10px;
  }

  .username{
    position: absolute;
    left: 59px;
    top: 100px;
    /* z-index: 10; */
    color: var(--text-color);
    font-size: 16px;
    cursor: pointer;
    .out-btn{
      width: 100px;
      line-height: 30px;
      color: #f00;
      background: #fff;
      box-shadow: 0px 25px 70px 0px rgba(25, 225, 225, 0.1);
      border-radius: 3px;
      position:absolute;
      left: 0;
      top: 30px;
      text-align:center;
    }

  }
  .logo{
    width: 240px;
    height: 120px;
    float: left;
    color: var(--text-color);
    box-sizing: border-box;
    padding: 48px 0 0 30px;
    font-size: 30px;
    letter-spacing: 10px;
    margin-right: 30px;
    position: relative;
    .select-venue{
      position: absolute;
      display: block;
      .tit{
        font-size: 16px;
        // online font-family: PingFangSC-Regular, PingFang SC;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: var(--text-color);
        line-height: 30px;
        letter-spacing: 0px;
        cursor: pointer;
        padding-right: 40px;
        background-repeat: no-repeat;
        background-position: right center;
        background-size: 14px auto;
        .small {
          font-size: 14px;
        }
        &.down-logo {

          background-image: url('../../assets/chevron-down.svg');
        }
      }
      .open{
        background-image: url('../../assets/ccc.png');
      }
      .list{
        width: 720px;
        padding: 0;
        box-sizing: border-box;
        background: var(--background-color-4);
        box-shadow: 0px 25px 70px 0px rgba(0,0,0,0.1000);
        border-radius: 5px;
        position: absolute;
        left: 0;
        top: 40px;
        letter-spacing: 0px;
        opacity: 0;
        height: 0;
        overflow: hidden;
        transition: opacity .3s;
        h1{
          font-size: 20px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: var(--text-color);
          line-height: 28px;
          margin-bottom: 50px;
        }
        ul{
          margin-bottom: 65px;
          max-height: 300px;
          overflow-y: auto;
          &::-webkit-scrollbar {
              @extend .scrollbar;
          }

          &::-webkit-scrollbar-track {
              @extend .scrollbar-track;
          }

          &::-webkit-scrollbar-thumb {
              @extend .scrollbar-thumb;
          }
          li{
            background: var(--background-color-3);
            border: 1px solid #5F5F5F;
            box-sizing: border-box;
            padding: 15px 20px;
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            align-items: center;
           // &::after {
             // content: '';
             // background-color: red;
            //  border: 1px solid #5F5F5F;
             // box-sizing: border-box;
             // padding: 15px 20px;
             // mask-repeat: no-repeat !important;
             // mask-position: 576px center;
            //  mask-size: 24px auto;
            //  mask: url('../../assets/chevron-right.svg');
            //}
            .name{
              font-size: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: var(--text-color);;
              line-height: 30px;
              width: 180px;
              float: left;
              // white-space: nowrap;
              // overflow: hidden;
              // text-overflow: ellipsis;
              // word-break: auto-phrase;
              margin-right: 14px;
            }
            .type-button{
              width: 150px;
              height: 30px;
              border-radius: 20px;
              box-sizing: border-box;
              line-height: 28px;
              font-size: 12px;
              font-family: SFProText-Medium, SFProText;
              font-weight: 500;
              margin-right: 106px;
              float: left;
              text-align: center;
            }
            .white{
              color: var(--text-color);
              border: 1px solid var(--background-color-4);
              background: var(--background-color-4);
            }
            .red{
              color: #F06185;
              border: 1px solid #F06185;
              background: transparent;
            }
            .green{
              color: #3BD578;
              border: 1px solid #3BD578;
              background: transparent;
            }
            .ring{
              width:24px;
              height: 30px;
              float: left;
              background-repeat: no-repeat;
              background-position: left center;
              background-size: contain;
              background-image: url('../../assets/lingdang.png');
            }
          }
        }
        .out-btn{
          height: 60px;
          background: var(--background-color-4);
          border: 2px solid var(--primary-color);
          // margin: 0 auto;
          text-align: center;
          line-height: 58px;
          box-sizing: border-box;
          font-size: 26px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: var(--primary-color);
          border-radius: 10px;
          @include montserrat-font(20px, normal, 600, var(--primary-color));
          display: flex;
          padding: 0px 2rem;
          align-items: center;
          justify-content: center;
          cursor: pointer;
        }
        .to-list-btn {
          background-color: var(--primary-color);
          height: 60px;
          color: #fff !important;
          cursor: pointer;
          border: 1px solid var(--primary-color);
          padding: 0px 2rem;
          border-radius: 10px;
          @include montserrat-font(20px, normal, 600, $white);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .button-container {
          display: flex;
          justify-content: space-between;
        }

        .search-container {
          margin-bottom: 1rem;
        }
      }
      .show{
        opacity: 1;
        height: auto;
        padding: 50px 50px 65px 50px;
      }

    }
  }
  .slt-wrp{
    width: 240px;
    float: left;
    margin-top: 60px;
  }
  .tip-wrp{
    float: right;
    margin-top: 60px;
    padding-bottom: 10px;
    border-bottom: 2px solid #EA3796;
    font-size: 16px;
    color: #EA3796;
    padding-right: 30px;
    position: relative;
    i{
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .carousel{
    float: right;
    margin-top: 66px;
    height: 40px;
    width: 500px;
    position:relative;
    h3 {
      font-size: 16px;
      color: #EA3796;
      line-height: 30px;
      margin: 0;
      position: relative;
      text-align: right;
      font-weight: bold;
      height: 40px;
      white-space: nowrap;
      font-family: PingFang SC-Regular, PingFang SC;
      span{
        border-bottom: 2px solid #EA3796;
        padding: 0 30px 10px 0;
        cursor: pointer;
      }
      i{
        position: absolute;
        right: 0;
        top: 10px;
      }
    }
    .list{
      padding: 20px;
      position: absolute;
      box-sizing: border-box;
      background: transparent;
      box-shadow: 0px 25px 70px 0px rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      display: inline-block;
      right: 0;
      top: 80px;

    }
  }
}
.pop-wrp{
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    background:rgba(33,36,41,.8);
    bottom: 0;
    right: 0;
    z-index: 102;
    min-width: 840px;
    h1{
      font-size: 24px;
      line-height: 33px;
      font-weight: 600;
      margin-bottom: 10px;
      color: var(--text-color);
    }
    h2{
      font-size: 20px;
      line-height: 25px;
      margin-bottom: 50px;
      color: varr(--primary-color);
    }
  }
  .name-wrap{
      width:840px;
      min-height: 300px;
      background:var(--background-color-3);
      box-sizing: border-box;
      padding: 60px 50px;
      position: relative;
      .close{
        width: 24px;
        height: 24px;
        position: absolute;
        top: 40px;
        right: 50px;
        color: #fff;
        font-size: 26px;
        line-height: 24px;
        cursor: pointer;
      }
      ul{
        width: 100%;
        border-top: 1px solid #5F5F5F;
        max-height: 255px;
        overflow-y: auto;
      }
      li{
        width: 100%;
        padding: 11px 120px 11px 20px;
        font-size: 20px;
        line-height: 28px;
        box-sizing: border-box;
        border-bottom: 1px solid #5F5F5F;
        background: #151C27;
        position: relative;
        cursor: pointer;
        word-break: break-word;
        color: #fff;
        .add{
          position: absolute;
          top: 11px;
          right: 20px;
          line-height: 28px;
          font-size: 16px;
        }
      }
  }
  .ask-wrap{
    width:840px;
    background:var(--background-color-3);
    box-sizing: border-box;
    padding: 55px 50px 65px 50px;
    position: relative;
    .close{
      width: 24px;
      height: 24px;
      position: absolute;
      top: 40px;
      right: 50px;
      color: #fff;
      font-size: 26px;
      line-height: 24px;
      cursor: pointer;
    }
    h1{
      width: 90%;
      font-size: 24px;
      font-family: PingFangSC-Semibold;
      color: #FFFFFF;
      line-height: 33px;
      text-align: center;
      margin: 0 auto 58px auto;
      word-break: break-word;
      span{
        color: #D13A90;
      }
    }
    .btns{
      width: 610px;
      margin: 0 auto;
      button{
        width: 280px;
        height: 60px;
        background: transparent;
        box-sizing: border-box;
        font-size: 26px;
        font-family: PingFangSC-Semibold;
        outline: none;
        cursor: pointer;
        display: block;
        &:nth-child(1){
          float: left;
          border: 2px solid #fff;
          color: #fff;
        }
        &:nth-child(2){
          float: right;
          border: 2px solid #D13A90;
          color: #D13A90;
        }
      }
    }
    .confirm{
       width: 280px;
        height: 60px;
        background: transparent;
        box-sizing: border-box;
        font-size: 26px;
        font-family: PingFangSC-Semibold;
        outline: none;
        cursor: pointer;
        display: block;
        margin: 0 auto;
        border: 2px solid #D13A90;
          color: #D13A90;
    }
    .inputItem{
      width: 100%;
      height: 50px;
      margin-bottom: 65px;
      position: relative;
      input{
        width: 100%;
        box-sizing: border-box;
        height: 50px;
        background: #151C27;
        border: 1px solid #5F5F5F;
        padding: 0 60px 0 15px;
        font-size: 16px;
        color: #fff;
        font-family:SFProText;
        outline: none;
      }
      i{
          position: absolute;
          top: 0;
          right: 20px;
          line-height: 50px;
          color: #fff;
          font-size: 20px;
          font-family:SFProText;
          font-style: normal;
        }
    }
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .pop-wrp{
    width: 100%;
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    background:rgba(33,36,41,.8);
    bottom: 0;
    right: 0;
    z-index: 102;
    min-width: 840px;
    h1{
      font-size: 24px;
      line-height: 33px;
      font-weight: 600;
      margin-bottom: 10px;
      color: #fff;
    }
    h2{
      font-size: 20px;
      line-height: 25px;
      margin-bottom: 50px;
      color: varr(--primary-color);
    }
    .bind{
      width: 100%;
      height:50px;
      background:rgba(21,28,39,1);
      border-top: 1px solid #5F5F5F;
      border-bottom: 1px solid #5F5F5F;
      box-sizing: border-box;
      padding: 0 20px;
      line-height: 50px;
      font-size: 20px;
      color: #fff;
      cursor: pointer;
      .el-icon-loading{
        margin-left: 6px;
        color: #fff;
      }
      i{
        float: right;
        line-height: 50px;
      }
      span{
        float: right;
        margin-right: 11px;
      }
      .red{
        color: #EA3796;
      }
      .grn{
        color: #24D788;
      }
    }
    .wbind{
      background-repeat: no-repeat;
      background-position: 512px 5px;
      background-size: auto 40px;
      background-image: url('../../assets/ctx.png');
    }
    .xbind{
      background-repeat: no-repeat;
      background-position: 482px 5px;
      background-size: auto 40px;
      background-image: url('../../assets/cxt.png');
    }
    .btns{
      margin: 65px auto 0 auto;
      width: 610px;
      button{
        width:280px;
        height:60px;
        outline: none;
        background: none;
        cursor: pointer;
        font-weight: 600;
      }

      .dark{
        border: 2px solid #fff;
        color: #fff;
        font-size: 26px;
        float: left;
      }
      .light{
        border: 2px solid #8E3771;
        color: #8E3771;
        font-size: 26px;
        float: right;
      }
      .usable{
        border: 2px solid #EA3796;
        color: #EA3796;
      }
    }
    .frist-step{
      width:840px;
      height:471px;
      background:var(--background-color-3);
      position: absolute;
      left: 50%;
      top: 50%;
      transform: rotate(-36deg);
      opacity: 0;
      margin: -235px 0 0 -538px;
      box-sizing: border-box;
      padding: 65px 50px 0 50px;
      transition: all 0.5s;
    }
    .normal{
      transform: rotate(0deg);
      opacity: 1;
      margin-left: -420px;
    }
    .second-step{
      width:840px;
      height:659px;
      background:var(--background-color-3);
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -328px 0 0 -420px;
      box-sizing: border-box;
      padding: 65px 50px 0 50px;
      h2{
        margin-bottom: 30px;
      }
      .upload-con{
        width: 100%;
        height: 280px;
        background: var(--background-color-3);
        border: 1px solid var(--background-color-4);
        box-sizing: border-box;
        position: relative;
        text-align: center;
        .close{
          width: 20px;
          position: absolute;
          height: 20px;
          right: 28px;
          top: 69px;
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center center;
          background-image: url('../../assets/c.png');
          cursor:pointer;
        }
        .icon{
          display: block;
          width: 100%;
          height: 35px;
          background-repeat: no-repeat;
          background-size: contain;
          background-position: center center;
          background-image: url('../../assets/upload.png');
          margin-top: 80px;
          margin-bottom: 30px;
        }
        h3{
          font-size: 20px;
          line-height: 28px;
          text-align: center;
          color: #fff;
          span{
            color: #D13A90;
          }
        }
        .demo{
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          bottom: 0;
        }
        .el-icon-loading{
          margin-top: 100px;
          font-size: 30px;
        }
        .file{
          width: 660px;
          height: 120px;
          background: transparent;
          position: relative;
          margin: 80px auto 0 auto;
          display:flex;
          flex-direction: row;
          box-sizing: border-box;
          padding: 20px;
          .in{
            width: 80px;
            height: 80px;
            margin-right: 20px;
            background-size: contain;
            background-image: url('../../assets/a.png');
            background-position:center center;
            background-repeat: no-repeat;
            flex: 0 0 auto;
          }
          .text{
            flex: 0 0 auto;
            text-align: left;
            width: 520px;
            .tit{
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              font-size: 24px;
              line-height: 33px;
              margin-bottom: 10px;
              margin-top: 5px;
            }
            .size{
              width: 100%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
              font-size: 20px;
              line-height: 28px;
            }
          }
        }
      }
    }
    .lst{
      width: 100%;
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .box{
        width:1250px;
        background:var(--background-color-3);
        box-sizing: border-box;
        padding: 65px 50px 65px 50px;
        .table-wrp{
          margin-bottom: 15px;
        }
        p{
          font-size: 18px;
          line-height: 25px;
          color: #fff;
        }
      }
    }
    .third-step{
      width:840px;
      height:369px;
      position: absolute;
      left: 50%;
      top: 50%;
      background:var(--background-color-3);
      box-sizing: border-box;
      padding: 60px 50px 0 50px;
      margin: -184px 0 0 -420px;
      .xero, .deputy{
        padding-left: 68px;
        background-size: 28px 28px;
        background-repeat: no-repeat;
        background-position-x: 20px;
        background-position-y: center;
      }
      .xero{
        background-image: url('../../assets/q.png');
      }
      .deputy{
        background-image: url('../../assets/b.png');
      }
    }
    .fouth-step{
      width:840px;
      position: absolute;
      left: 50%;
      top: 50%;
      background:var(--background-color-3);
      box-sizing: border-box;
      padding: 60px 50px 0 50px;
      h1{
        margin-bottom: 50px;
      }
      .input-wrp{
        width: 100%;
        position: relative;
        input{
          outline: none;
          width: 100%;
          background: #151C27;
          height: 50px;
          box-sizing: border-box;
          border: 1px solid #5F5F5F;
          font-size: 16px;
          padding-left: 15px;
          color: #fff;
        }
      }
    }
    .xero-wrp{
      height: 383px;
      margin: -191px 0 0 -420px;
      .input-wrp{
        input{
          padding-left: 45px;
        }
      }
      span{
        position: absolute;
        line-height: 50px;
        left: 20px;
        top: 0;
        font-size: 20px;
      }
    }
    .deputy-wrp{
      height: 416px;
      margin: -208px 0 0 -420px;
      span{
        position: absolute;
        line-height: 50px;
        right: 20px;
        top: 0;
        font-size: 20px;
      }
    }
    .last-step{
      width:840px;
      height:300px;
      position: absolute;
      left: 50%;
      top: 50%;
      background:var(--background-color-3);
      box-sizing: border-box;
      padding: 60px 50px 0 50px;
      margin: -150px 0 0 -420px;
    }
    .pop-confirm{
      width: 1250px;
      height: 280px;
      background: transparent;
      position: absolute;
      left: 50%;
      top: 50%;
      margin: -140px 0 0 -625px;
      .triple{
        text-align: center;
        button{
          width: 280px;
          height: 60px;
          background: transparent;
          box-sizing: border-box;
          font-size: 26px;
          font-family:PingFangSC-Semibold,PingFang SC;
        }
        button:nth-child(1), button:nth-child(2){
          margin-right: 50px;
        }
        button:nth-child(1){
          color: #fff;
          border: 2px solid #FFFFFF;
        }
        button:nth-child(3), button:nth-child(2){
          color:#D13A90;
          border: 2px solid #D13A90;
        }
      }
    }
  }
  .table-wrp{
    width: 100%;
    background: #151C27;
    margin-bottom: 30px;
    h2{
      width: 100%;
      box-sizing: border-box;
      padding: 21px 0 21px 30px;
      font-size: 20px;
      line-height: 28px;
      color: #fff;
      position: relative;
      .el-icon-arrow-down, .el-icon-arrow-right{
        position: absolute;
        right: 20px;
        top: 32px;
      }
      .el-icon-refresh{
        font-size: 22px;
        margin-left: 30px;
        cursor: pointer;
        color: #EA3796;
      }
    }
    .table-con{
      overflow: hidden;
      transition: all .5s;
    }
    input{
      width: 100%;
      margin: 0;
      padding: 0;
      background: none;
      outline: none;
      border: none;
      font-size: 16px;
      color: #fff;
      box-sizing: border-box;
      padding: 0 10px;
      text-align: center;
    }
  }


  .weather-container {

    .right {
      .temperature {
        @include alata-fonts(24px, normal, 400, var(--text-color));
        &.3 {
          font-size: 20px !important;
        }
        > span {
          font-size: 16px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/nav/headcon.vue